import { useQueryParams } from '@/hooks';
import usePagination from '@/hooks/usePagination';
import { useEffect } from 'react';

const useUsersPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};

export default useUsersPagination;
